import { useQuery } from '@tanstack/react-query';
import { getFeatures } from './api';

/**
 * Feature flags enabled for the current organization. Fetched once and cached;
 * gated UI reads it synchronously via {@link useFeature}. Backed by `GET /features`,
 * which resolves the admin Lab's rollout rules (override → GA → % cohort) server-side.
 */
export function useFeatures() {
  return useQuery({
    queryKey: ['features'],
    queryFn: getFeatures,
    staleTime: 60_000,
  });
}

/** Is a feature flag on for this organization? Defaults to false while loading or
 * if the key is unknown — so gated UI stays hidden until proven enabled. */
export function useFeature(key: string): boolean {
  const { data } = useFeatures();
  return data?.features[key] ?? false;
}
